import { Component, Input, OnInit } from '@angular/core';
import { AlertService, ComponentsStoreService, IAlertType } from '../../../_shared/services';
import { ClrDatagridModule, ClrDatagridSortOrder, ClrIconModule } from '@clr/angular';
import {Components, Personen} from '../../../_shared/interfaces';
import { ActivatedRoute, RouterLink } from "@angular/router";
import { NgIf } from "@angular/common";
import { ComponentSearchComponent } from "../component-search/component-search.component";
import { EditSpecificationComponent } from "./edit-specification/edit-specification.component";
import {ClarityIcons, pencilIcon, trashIcon} from "@cds/core/icon";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";

@Component({
  selector: 'app-component-parts',
  standalone: true,
  imports: [
    NgIf,
    ClrDatagridModule,
    RouterLink,
    ClrIconModule,
    ComponentSearchComponent,
    EditSpecificationComponent
  ],
  templateUrl: './component-parts.component.html',
  styleUrl: './component-parts.component.sass'
})
export class ComponentPartsComponent implements OnInit {
  editSpecificationsForm: FormGroup;
  components: Components[] = [];
  technologies: Components[] = [];
  descSort = ClrDatagridSortOrder.DESC;
  loading: boolean = true;
  editedChild: string = '';
  quantity: number | undefined = 0;
  technology: string = 'false';
  specificationText: string | undefined = '';
  position: number | undefined = 0;
  technicalDrawing: string = '';

  @Input() componentID: string | any;
  @Input() editpos: number = 0;  // 0 = Anzeige; 1 = Änderungsmodus, 2 = Position ändern

  constructor(
    private fb: FormBuilder,
    private compss: ComponentsStoreService,
    private alertDispatcher: AlertService,
    private route: ActivatedRoute
  ) {
    ClarityIcons.addIcons(trashIcon, pencilIcon);

    this.editSpecificationsForm = this.fb.group({
      parent_component: [''],
      technical_drawing: [''],
      number_of_subparts: [this.quantity, [Validators.pattern('^\\d*$')]],
      specification: [this.specificationText],
      position: [this.position],
      active: true,
      description: [''],
      documents: [''],
      material: [''],
      name: [''],
      number_of_pieces: 0,
      number_of_pieces_in_stock: 0,
      standard: false,
      taric: '0',
      technology: false,
      weight: [''],
    });
  }

  ngOnInit() {
    this.route.params.subscribe(params => {
      this.technicalDrawing = params['technical_drawing'];
      this.getComponents(this.technicalDrawing);
      this.getTechnologies(this.technicalDrawing);
      this.editpos = 0;
    });
  }

  private getComponents(component: string) {
    this.compss.getComponentsChildren(component, 'false').subscribe({
      next: data => {
        if (!data || !data.object || data.object.length === 0) {
          this.alertDispatcher.show({
            message: ' Keine Komponenten gefunden! ',
            clrAlertType: IAlertType.WARNING
          }, 2000);
        }
        this.components = data.object;
      },
      complete: () => {
        this.loading = false;
      },
      error: () => {
        return
      }
    });
  }

  private getTechnologies(component: string) {
    this.compss.getComponentsChildren(component, 'true').subscribe({
      next: data => {
        if (!data || !data.object || data.object.length === 0) {
          this.alertDispatcher.show({
            message: ' Keine Verfahren gefunden! ',
            clrAlertType: IAlertType.WARNING
          }, 2000);
        }
        this.technologies = data.object;
      },
      complete: () => {
        this.loading = false;
      },
      error: () => {
        return
      }
    });
  }

  onSubmit(): void {
    if (this.editSpecificationsForm.valid) {
      this.updateSpecification(this.editSpecificationsForm.value);
    }
  }

  startEdit(component: Components, technology: boolean) {
    this.editedChild = component.technical_drawing;
    this.quantity = component.number_of_subparts ?? 0;
    this.technology = technology.toString();
    this.specificationText = component.specification ?? '';
    this.position = component.position ?? 0;
    this.editSpecificationsForm.reset({
      parent_component: this.componentID,
      technical_drawing: component.technical_drawing,
      number_of_subparts: component.number_of_subparts ?? 0,
      specification: component.specification ?? '',
      position: component.position ?? 0,
      active: component.active ?? true,
      description: component.description ?? '',
      documents: component.documents ?? '',
      material: component.material ?? '',
      name: component.name ?? '',
      number_of_pieces: component.number_of_pieces ?? 0,
      number_of_pieces_in_stock: component.number_of_pieces_in_stock ?? 0,
      standard: component.standard ?? false,
      taric: component.taric ?? '0',
      technology,
      weight: component.weight ?? '',
    });
    this.editpos = 2;
  }

  cancelEdit() {
    this.editpos = 0;
    this.editedChild = '';
    this.quantity = 0;
    this.technology = 'false';
    this.specificationText = '';
    this.position = 0;
    this.editSpecificationsForm.reset({
      parent_component: '',
      technical_drawing: '',
      number_of_subparts: 0,
      specification: '',
      position: 0,
      active: true,
      description: '',
      documents: '',
      material: '',
      name: '',
      number_of_pieces: 0,
      number_of_pieces_in_stock: 0,
      standard: false,
      taric: '0',
      technology: false,
      weight: '',
    });
  }

  updateTable() {
    this.getComponents(this.componentID);
    this.getTechnologies(this.componentID)
  }

  updateSpecification(component: Components) {
    this.compss.updateSpecification(component)
      .subscribe({
        next: () => {
          this.alertDispatcher.show({
            message: 'Spezifikation der Komponente ' + component.name + ' wurde aktualisiert!',
            clrAlertType: IAlertType.INFO
          }, 2000);

        },
        complete: () => {
          this.updateTable();
          this.cancelEdit();
        },
        error: () => {
          return
        }
      })
  }

  removeChild(componentParent: string, componentChild: string, position: number | undefined) {
    if (position === undefined) {
    console.error("Position is undefined, cannot remove child.");
    return;
  }
    if (confirm('Wollen Sie die Teilkomponente ' + componentChild + ' wirklich aus der Teileliste von ' + componentParent + ' löschen?')) {
      this.compss.removeComponentsChild(componentParent, componentChild, position)
        .subscribe({
          next: () => {
          },
          complete: () => {
            this.getComponents(this.componentID);
            this.getTechnologies(this.componentID)
          },
          error: () => {
            return
          }
        });
    }
  }
}
